import { SettoreVO } from "@app/shared/vo/settoreVO";
import { AutorizzazioneVO } from "@app/shared/vo/autorizzazioneVO";

export class ProfiloVO {
  codice: string;

  nome: string;

  autorizzazioni: AutorizzazioneVO[];

  settori: SettoreVO[];
}
